import type { ShareSecurityLevel, WelcomeMatConfig } from '@carboncopyco/types';
import { Modal } from '@carboncopyco/ui';
import { useShowtimeUrl } from '@carboncopyco/components';

export interface FormPreviewModalProps {
  open?: boolean;
  organizationName: string;
  presenterName: string;
  organizationLogo: string;
  emailDomain: string;
  securityLevel: ShareSecurityLevel;
  assetType: 'demo' | 'tour';
  onClose: () => void;
  welcomeMatConfig?: WelcomeMatConfig;
  welcomeMatTitle: string;
}

export const FormPreviewModal = ({
  open,
  assetType,
  presenterName,
  emailDomain,
  securityLevel,
  onClose,
  welcomeMatConfig,
  welcomeMatTitle,
}: FormPreviewModalProps) => {
  const { showtimeWelcomeMatPreviewUrl } = useShowtimeUrl();
  const src = showtimeWelcomeMatPreviewUrl({
    securityLevel,
    assetType,
    requireName: welcomeMatConfig.requireName,
    requireEmail: welcomeMatConfig.requireEmail,
    presenterName,
    emailDomain,
    welcomeMatTitle,
  });

  return (
    <Modal
      noPadding
      open={open}
      noBackground
      onClose={onClose}
      floatingCloseButton
      containerClass="z-100"
    >
      <iframe
        title={welcomeMatTitle}
        src={src}
        className="w-[500px] h-[640px]"
      />
    </Modal>
  );
};
